app
    .controller('CoachPresentationFormCtrl', function CoachImageFormCtrl($http) {

        this.ok = () => {
            const fd = new FormData();

            const file = document.getElementById('dp').files[0];

            if(file){
                fd.append('photofile', file);
            }
            if(this.coach.presentation.video){
                fd.append('video', this.coach.presentation.video);
            }
            fd.append('description[englishValue]', this.coach.presentation.description.englishValue);
            fd.append('description[frenchValue]', this.coach.presentation.description.frenchValue);
            $http.post(`/coach/presentation/${this.resolve.coach.id}`,fd, {
                headers: {'Content-Type': undefined },
            }).then(()=>{
                this.close();
            });
        };

        this.cancel = () => {
            this.dismiss();
        };

        this.$onInit = () => {
            this.coach = this.resolve.coach;

        };
    })
    .component('coachPresentationForm', {
        template: `
        <div class="modal-header">
            <h3 class="modal-title" id="modal-title">{{ 'modal.presentationForm.title' | translate}}</h3>
        </div>
        <div class="modal-body" id="modal-body">
            <uib-tabset active="active">
                <uib-tab index="0" heading="PICTURE">
                    <div class="form-group mt-3">
                    <div style="display: flex; justify-content: center; align-items: center;" class="mb-2">
                        <img ng-src="/upload/{{$ctrl.coach.presentation.photo}}"  style="max-width: 100%; max-height: 150px;"/>
                    </div>

                    <label>{{ 'modal.presentationForm.label.picture' | translate}}</label>
                    <label class="custom-file form-control sg-custom-file">
                        <input type="file" id="dp" class="custom-file-input" ng-model="$ctrl.file"/>
                        <label for="dp" class="custom-file-label">{{ 'modal.presentationForm.label.chooseFile' | translate}}</label>
                    </label>
                    <span class="form-text text-muted"><small>{{ 'modal.presentationForm.helpText.picture' | translate}}</small></span>
                </div>
                </uib-tab>
                <uib-tab index="1" heading="VIDEO">
                    <div class="form-group  mt-3">
                        <label for="">{{ 'modal.presentationForm.label.video' | translate}}</label>
                        <input type="text" class="form-control" placeholder="https://" domain-validate="(youtube|vimeo)" ng-model="$ctrl.coach.presentation.video">
                        <span class="form-text text-muted"><small>{{ 'modal.presentationForm.helpText.video1' | translate}}</small></span>
                        <span class="form-text text-muted"><small>{{ 'modal.presentationForm.helpText.video2' | translate}}</small></span>
                    </div>
                </uib-tab>
            </uib-tabset>
            <div class="form-group">
                <label>
                    {{ 'modal.presentationForm.label.description' | translate}}
                </label>
                <textarea class="form-control" ng-model="$ctrl.coach.presentation.description.englishValue" placeholder="Description in english"></textarea>
                <textarea class="form-control mt-2" ng-model="$ctrl.coach.presentation.description.frenchValue" placeholder="Description in french"></textarea>
                <span class="form-text text-muted"><small>{{ 'modal.presentationForm.helpText.description' | translate}}</small></span>

            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-save" type="button" ng-click="$ctrl.ok()">{{ 'modal.presentationForm.button.save' | translate}}</button>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachPresentationFormCtrl'
    });
